import React from 'react'
import { Layout, Button } from 'antd'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
import TopBar from 'components/LayoutComponents/TopBar'
import Menu from 'components/LayoutComponents/Menu'
import style from './style.module.scss'
import { connect } from '../../redux/index'

@withRouter
@connect(({ user, settings, device, profile }) => ({ user, settings, device, profile }))
class MainLayout extends React.PureComponent {
  state = {
    inActivityMessage: false,
  }

  render() {
    const { settings, children } = this.props
    const { inActivityMessage } = this.state
    const {
      isBorderless,
      isSquaredBorders,
      isFixedWidth,
      isMenuShadow,
      isMenuTop,
      portalVersion,
    } = settings
    return (
      <React.Fragment>
        {inActivityMessage && (
          <div className={style.noDataDiv}>
            <p className={style.noData}>
              The web page has timed-out due to inactivity. Hit &#39;Ok&#39; to continue using the
              Circadia Webportal.
              <br />
              <Button
                type="primary"
                onClick={() => {
                  const { location: pageLocation } = window
                  pageLocation.reload()
                }}
              >
                <i className="fa fa-refresh" />
                &nbsp;&nbsp;OK
              </Button>
            </p>
          </div>
        )}
        <Layout
          className={classNames({
            settings__borderLess: isBorderless,
            settings__squaredBorders: isSquaredBorders,
            settings__fixedWidth: isFixedWidth,
            settings__menuShadow: isMenuShadow,
            settings__menuTop: isMenuTop,
          })}
        >
          <Menu />
          <Layout>
            <Layout.Header style={{ zIndex: 5 }}>
              <TopBar />
            </Layout.Header>
            <Layout.Content style={{ height: '100%', position: 'relative' }}>
              <div className="utils__content">{children}</div>
            </Layout.Content>
            <div className={`${style.footer} text-center`}>
              <p className="text-muted">
                Version {portalVersion} -&nbsp;
                <a
                  href="https://circadia.health/pages/privacy-cookies-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
                &nbsp; - &nbsp;
                <a
                  href="https://circadia.health/pages/support"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Support
                </a>
              </p>
            </div>
          </Layout>
        </Layout>
      </React.Fragment>
    )
  }
}

export default MainLayout
